import React, {useEffect} from 'react';
import './App.css';
import './Sidebar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'leaflet/dist/leaflet.css';
import LoginPage from './components/common/login';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import UsersMapTable from './components/pages/m4/predioPrograma/usersMap';
import PrivateRoute from './components/common/PrivateRoute';
import Header from './components/common/header';
import LocalidadesMapTable from './components/pages/m4/predioPrograma/localidadMap';
import PrediosMapTable from './components/pages/m4/predioPrograma/predioMap';
import {LoadScript} from '@react-google-maps/api';
import CreatePrograma from './components/pages/m4/predioPrograma/createPrograma';
import HistoricoPrograma from './components/pages/m4/predioPrograma/searchPrograma';
import {AuthProvider} from './components/context/auth.context';
import FormBuilder from './components/pages/m4/listaControl/formBuilder';
import FormEdit from './components/pages/m4/listaControl/formEdit';
import CreateUser from './components/common/manageUsers/createUser';
import ViewUser from './components/common/manageUsers/viewUser';
import ViewTableUsers from './components/common/manageUsers/viewTableUser';
import FormsTable from './components/pages/m4/listaControl/formTable';
import DynamicFormRenderer from './components/pages/m4/listaControl/formRender';
import FormResults from './components/pages/m4/listaControl/formResults';
import PrediosMapTableSimplificado from './components/pages/m4/predioPrograma/predioSimplificado';
import RegisterUser from './components/common/manageUsers/registerUser';
import UpdateUserAccess from './components/common/manageUsers/updateUserAccess';
import Organizations from './components/common/manageUsers/organizations';
import FormBuilderMail from "./components/pages/arauco/form/formBuilderMail";
import FormEditMail from "./components/pages/arauco/form/formEditMail";
import CreateUserBasic from "./components/pages/arauco/createUserBasic";
import ViewUserBasic from "./components/pages/arauco/viewUserBasic";
import DynamicFormRendererMail from "./components/pages/arauco/form/formRenderMail";
import CreateDistributionListArauco from "./components/pages/arauco/distribution/createDistributionListArauco";
import ViewDistributionListArauco from "./components/pages/arauco/distribution/viewDistributionListArauco";
import {Home} from "./components/common/home";
import UpdateDistributionListArauco from "./components/pages/arauco/distribution/updateDistributionListArauco";
import FormsTableArauco from "./components/pages/arauco/form/FormsTableArauco";
import {listenForSubmissionSuccess} from "./service/hook/useNotifications";
import CursosAdmin from './components/pages/m4/cursos/cursosAdmin';
import MisCursos from './components/pages/m4/cursos/misCursos';
import CursosExternosAdmin from './components/pages/m4/cursosExternos/cursosExternosAdmin';
import MisCursosExternos from './components/pages/m4/cursosExternos/misCursosExternos';
import MiPerfil from './components/common/miPerfil';

function App() {
    useEffect(() => {
        const handleOnline = async () => {
            console.log('🌐 Conexión restaurada');
            try {
                const sw = await navigator.serviceWorker.ready;

                // Intenta Background Sync primero
                await sw.sync.register('submission-sync');

                // Y también fuerza manualmente por si el sync falla
                sw.active?.postMessage({ type: 'FORCE_SYNC' });
            } catch (error) {
                console.log('Error en sync:', error);
            }
        };

        window.addEventListener('online', handleOnline);
        return () => window.removeEventListener('online', handleOnline);
    }, []);

    useEffect(() => {
        const unsubscribe = listenForSubmissionSuccess(() => {
            console.log('Submission enviado exitosamente');
        });
        return unsubscribe;
    }, []);
    return (
        <AuthProvider>
            <BrowserRouter>
                <LoadScript googleMapsApiKey="AIzaSyDTiMZJ1AgeaWmarG9pIpnHsLSCy10unuk" libraries={["places"]}>
                    <Header></Header>
                    <div className="app-layout">
                        <Routes>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/home" element={
                                <PrivateRoute org={"ALL"}>
                                    <Home/>
                                </PrivateRoute>
                            }
                            />
                            <Route path="/perfil" element={
                                <PrivateRoute org={"ALL"}>
                                    <MiPerfil/>
                                </PrivateRoute>
                            }
                            />
                            <Route path="/m4/users" element={
                                <PrivateRoute org={"M4"}>
                                    <UsersMapTable/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/localidades" element={
                                <PrivateRoute org={"M4"}>
                                    <LocalidadesMapTable/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/predios" element={
                                <PrivateRoute org={"M4"}>
                                    <PrediosMapTable/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/predios/simplificado" element={
                                <PrediosMapTableSimplificado/>}
                            />
                            <Route path="/m4/programa/create" element={
                                <PrivateRoute org={"M4"}>
                                    <CreatePrograma/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/programa/historico" element={
                                <PrivateRoute org={"M4"}>
                                    <HistoricoPrograma/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/form/create" element={
                                <PrivateRoute org={"M4"}>
                                    <FormBuilder/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/form/list" element={
                                <PrivateRoute org={"M4"}>
                                    <FormsTable/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/form/:id" element={
                                <DynamicFormRenderer/>}
                            />
                            <Route path="/m4/form/:id/results" element={
                                <PrivateRoute org={"M4"}>
                                    <FormResults/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/form/:id/edit" element={
                                <PrivateRoute org={"M4"}>
                                    <FormEdit/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/create" element={
                                <PrivateRoute org={"ALL"}>
                                    <CreateUser/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/view" element={
                                <PrivateRoute org={"ALL"}>
                                    <ViewUser/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/view/:id" element={
                                <PrivateRoute org={"ALL"}>
                                    <ViewUser/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/roles" element={
                                <PrivateRoute org={"ALL"}>
                                    <UpdateUserAccess/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/roles/:id" element={
                                <PrivateRoute org={"ALL"}>
                                    <UpdateUserAccess/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/table" element={
                                <PrivateRoute org={"ALL"}>
                                    <ViewTableUsers/>
                                </PrivateRoute>}
                            />
                            <Route path="/users/register" element={
                                <PrivateRoute org={"ALL"}>
                                    <RegisterUser/>
                                </PrivateRoute>}
                            />
                            <Route path="/organizations" element={
                                <PrivateRoute org={"ALL"}>
                                    <Organizations/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/cursos/admin" element={
                                <PrivateRoute org={"M4"}>
                                    <CursosAdmin/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/cursos/mis-cursos" element={
                                <PrivateRoute org={"M4"}>
                                    <MisCursos/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/cursos-externos/admin" element={
                                <PrivateRoute org={"M4"}>
                                    <CursosExternosAdmin/>
                                </PrivateRoute>}
                            />
                            <Route path="/m4/cursos-externos/mis-cursos-externos" element={
                                <PrivateRoute org={"M4"}>
                                    <MisCursosExternos/>
                                </PrivateRoute>}
                            />


                            <Route path="/arauco/form/:id" element={
                                <DynamicFormRendererMail/>}
                            />
                            <Route path="/arauco/form/:id/results" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <FormResults/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/form/create" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <FormBuilderMail/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/form/list" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <FormsTableArauco/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/form/:id/edit" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <FormEditMail/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/user/create" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <CreateUserBasic/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/user/view" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <ViewUserBasic/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/distribution/create" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <CreateDistributionListArauco/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/distribution/:id" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <UpdateDistributionListArauco/>
                                </PrivateRoute>}
                            />
                            <Route path="/arauco/distribution/view" element={
                                <PrivateRoute org={"ARAUCO"}>
                                    <ViewDistributionListArauco/>
                                </PrivateRoute>}
                            />

                            {/* Catch-all: cualquier ruta no definida */}
                            <Route path="*" element={<Navigate to="/home" replace/>}/>
                        </Routes>
                    </div>
                </LoadScript>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
